import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap";

const TotalRevenueModal = ({ isOpen, toggle, totalRevenue }) => {
  const _closeModal = () => {
    toggle();
  };

  const _cancelHandler = () => {
    _closeModal();
  };

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      toggle={() => _closeModal()}
      scrollable
      centered
    >
      <ModalHeader toggle={() => _closeModal()}>
        Total Revenue Plans
      </ModalHeader>
      <ModalBody>
        <Table responsive>
          <thead>
            <tr>
              <th>Group</th>
              <th>Subscription Revenue</th>
              <th>Media Revenue</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{totalRevenue?.name}</td>
              <td>
                $
                {totalRevenue?.revenue?.totalRevenue -
                  totalRevenue?.revenue?.mediaRevenue}
              </td>
              <td>${totalRevenue?.revenue?.mediaRevenue}</td>
              <td>${totalRevenue?.revenue?.totalRevenue}</td>
            </tr>
          </tbody>
        </Table>
      </ModalBody>
      <ModalFooter>
        <Button
          color="link"
          className="closeBtn"
          onClick={() => _cancelHandler()}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TotalRevenueModal;
